import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from 'react-admin';

import { ResourceDefinition, ResourceSections } from 'src/types';

export const UsersProgramsResource: ResourceDefinition = {
  name: 'users_programs',
  section: ResourceSections.PORTAL,

  permissions: {
    list: ['programs:read'],
    create: ['programs:edit'],
    edit: ['programs:edit'],
  },

  extension: {
    idKey: ['user_id', 'program_id'],
    operations: {
      [GET_LIST]: { operationName: 'portal_users_programs' },
      [GET_ONE]: { operationName: 'portal_users_programs' },
      [GET_MANY]: { operationName: 'portal_users_programs' },
      [GET_MANY_REFERENCE]: { operationName: 'portal_users_programs' },
    },
  },
};

export default UsersProgramsResource;
